<template>
    <div class="room-setting-group-component p-5">
        <div v-if="isWebinar || isRoomMode('exam')" class="room-setting-group-disable-wrap">
          <p>{{ setDisableText() }}</p>
        </div>
        <div v-else class="room-setting-content-wrap">
            <div class="room-setting-content-box">
                <h6 class="room-setting-content-title">
                    {{ $t("setting.group.title") }}
                    <div v-if="isRoomMode('group')"
                          class="group-on">{{ $t('setting.group.ongoing') }}</div>
                </h6>
                <div class="room-setting-content-text-box">
                    <p class="room-setting-content-text">{{ $t("setting.group.explain") }}</p>
                </div>
            </div>
            <div class="room-setting-content-box">
                <h6 class="room-setting-content-title">{{ $t("setting.group.make") }}</h6>
                <div class="room-setting-input-box">
                    <GrmSelect :label="$t('group.setting.amount')"
                               v-model="roomGroupCount"
                               :white="true"
                               :options="[
                      { value: 2, title: $t('group.setting.groupCount', { '0' : '2' }) , selected: roomGroupCount === 2},
                      { value: 3, title: $t('group.setting.groupCount', { '0' : '3' }) , selected: roomGroupCount === 3},
                      { value: 4, title: $t('group.setting.groupCount', { '0' : '4' }) , selected: roomGroupCount === 4},
                      { value: 5, title: $t('group.setting.groupCount', { '0' : '5' }) , selected: roomGroupCount === 5},
                      { value: 6, title: $t('group.setting.groupCount', { '0' : '6' }) , selected: roomGroupCount === 6},
                      { value: 7, title: $t('group.setting.groupCount', { '0' : '7' }) , selected: roomGroupCount === 7},
                      { value: 8, title: $t('group.setting.groupCount', { '0' : '8' }) , selected: roomGroupCount === 8},
                      { value: 9, title: $t('group.setting.groupCount', { '0' : '9' }) , selected: roomGroupCount === 9},
                      { value: 10, title: $t('group.setting.groupCount', { '0' : '10' }) , selected: roomGroupCount === 10},
                    ]"
                    />
                </div>
                <div class="room-setting-input-box">
                    <label class="room-setting-label">
                        <input  type="checkbox" name="useChat" class="room-setting-radio"
                                v-model="showRoomGroupUserInFilmArea">
                        <span>{{ $t("setting.group.topVideo") }}</span>
                    </label>
                </div>
                <div v-if="!isRoomMode('group')"
                     class="room-setting-input-box">
                    <label class="room-setting-label">
                        <input  type="checkbox" name="useChat" class="room-setting-radio"
                                v-model="showRoomGroupUserAutoDivide">
                        <span>{{ $t("setting.group.random") }}</span>
                    </label>
                </div>
            </div>
            <div class="room-setting-group-btn-box">
                <template v-if="!isRoomMode('group')">
                    <button class="room-group-setting-button start"
                            @click="onStartRoomGroupDiscussion">{{ $t("setting.group.start") }}</button>
                </template>
                <template v-else>
                    <button class="room-group-setting-button edit" @click="onChangeRoomGroupDiscussion">{{ $t("group.setting.change") }}</button>
                    <button class="room-group-setting-button end" @click="onEndRoomGroupDiscussion">{{ $t("group.setting.quit") }}</button>
                </template>
            </div>
        </div>
    </div>
</template>

<script>
import {mapActions, mapGetters, mapMutations} from "vuex";
import GrmSelect from "@/components/Common/select/GrmSelect.vue";
import _ from "lodash";

export default {
    components: {
        GrmSelect
    },
    data(){
        return{
            isChatMode: false,
            roomGroupCount: 2,
            showRoomGroupUserInFilmArea: true,
            showRoomGroupUserAutoDivide: false,
            createRoomGroupId: 'group-'
        }
    },
    computed:{
        ...mapGetters('room', [
            'isRoomMode'
        ]),
        ...mapGetters('user', [
            'isParticipantRole',
            'hasEmceeRole',
            'roomUserList',
        ]),
        ...mapGetters('roomGroup', [
            'roomGroupListNoDefaultActive',
        ]),
        ...mapGetters('call', [
            'roomCall',
            'isWebinar'
        ])
    },
    created() {
        this.showRoomGroupUserInFilmArea = !this.roomCall.hideRoomGroupUserInFilmArea
    },
    mounted(){
        if(this.isRoomMode('group')) {
            this.roomGroupCount = this.roomGroupListNoDefaultActive.length
        } else {
            this.roomGroupCount = 2;
        }
    },
    methods:{
        ...mapActions('room', [
            'changeRoomMode'
        ]),
        ...mapActions('roomGroup',[
            'createAndStartRoomGroup',
            'endRoomGroup',
            'addRoomGroup',
            'removeRoomGroup',
            'changeHideRoomGroupUserInFilmArea',
        ]),
        ...mapMutations('roomSetting', ['CHANGE_SETTING_DATA']),
        async onStartRoomGroupDiscussion() {
            if(this.roomGroupCount < 2) return;

            let roomGroupList = this.createRoomGroupList();

            this.createAndStartRoomGroup({roomGroupList, hideRoomGroupUserInFilmArea: !this.showRoomGroupUserInFilmArea, useContentLayout: false})
            this.changeRoomMode({roomMode: 'group'})
            this.$modal('RoomSettingModal')
        },

        async onChangeRoomGroupDiscussion() {
            if(!this.showRoomGroupUserInFilmArea != this.roomCall.hideRoomGroupUserInFilmArea) {
                this.changeHideRoomGroupUserInFilmArea(!this.showRoomGroupUserInFilmArea)
            }
            if(this.roomGroupCount < 2) return;

            let currentRoomGroupList = this.roomGroupListNoDefaultActive;
            let diffCount = currentRoomGroupList.length - this.roomGroupCount
            if(diffCount > 0) { // 그룹 제거
                let roomGroupList = currentRoomGroupList.slice(this.roomGroupCount)
                this.removeRoomGroup(roomGroupList);

            } else if (diffCount < 0) { // 그룹 추가
                let roomGroupList = this.createRoomGroupListByIndex(currentRoomGroupList.length + 1, this.roomGroupCount)
                this.addRoomGroup(roomGroupList)
            }
            this.$modal('RoomSettingModal')
        },
        onEndRoomGroupDiscussion() {
            this.$alert({
                text: this.$t('group.setting.quitText'),
                ok: () => {
                    this.endRoomGroup({roomMode: 'call'})
                    this.$modal('RoomSettingModal')
                },
            })
        },
        createRoomGroupList() {
            let roomGroupCount = this.roomGroupCount < 2 ? 2 : this.roomGroupCount
            let roomGroupList = this.createRoomGroupListByIndex(1, roomGroupCount)

            if(!this.showRoomGroupUserAutoDivide) {
                return roomGroupList;
            }
            let randomUserList = _.shuffle(_.cloneDeep(this.roomUserList).filter(ru => !this.hasEmceeRole(ru)).map(ru => ru.userId))

            let roomGroupListLength = roomGroupList.length - 1
            let roomGroupListIndex = 0
            for(let i = 0 ; i <randomUserList.length; i++ ){
                roomGroupList[roomGroupListIndex].userIdList.push(randomUserList[i])
                roomGroupListIndex = roomGroupListIndex >= roomGroupListLength ? 0 : roomGroupListIndex + 1
            }

            return roomGroupList;
        },
        createRoomGroupListByIndex(startIndex, endIndex) {
            let roomGroupList = []
            for(let i = startIndex; i <= endIndex; i++ ) {
                roomGroupList.push({
                    roomGroupId: this.createRoomGroupId + i,
                    roomGroupIndex: i,
                    groupName: this.$t('group.setting.group') + i,
                    userIdList: []
                })
            }
            return roomGroupList
        },
        setDisableText(){
            if(this.isWebinar) {
              return this.$t('setting.group.disable.live');
            } else if(this.isRoomMode('exam')) {
              return this.$t('setting.group.disable.exam')
            } else {
              return this.$t('setting.group.disable.default')
            }
        }
    }
}
</script>

<style lang='scss' scoped>
.room-setting-group-component{
    padding-bottom: 80px;
    position: relative;
    .room-setting-content-title{
        display: flex;
        align-items: center;
        .group-on{
            display: flex;
            justify-content: center;
            align-items: center;
            margin-left: 12px;
            padding: 4px 0;
            width: 60px;
            background-color: #4bbbc0;
            border-radius: 10px;
            color: #fff;
            font-size: 12px;
            line-height: 12px;
        }
    }
    .room-setting-group-btn-box{
        display: flex;
        justify-content: space-between;
        position: absolute;
        bottom: 20px;
        left: 20px;
        width: calc(100% - 40px);
        .room-group-setting-button{
            display: flex;
            justify-content: center;
            align-items: center;
            height: 40px;
            color: #fff;
            border-radius: 10px;
            font-size: 16px;
            &.start{
                width: 100%;
                background-color: #59f;
                &:hover{
                    background-color: #1b59f6;
                }
            }
            &.end{
                width: calc(50% - 10px);
                background-color: #d05;
                &:hover {
                    background-color: #f05;
                }
            }
            &.edit{
                width: calc(50% - 10px);
                background-color: $mainColor;;
                &:hover{
                    background-color: #39f;
                }
            }
        }
    }
    .room-setting-group-disable-wrap{
      text-align: center;
      color: #999;
    }
}
[grm-device-mobile]{
    @media (max-height: 610px) and (orientation: landscape) {
        .room-setting-group-component{
            .room-setting-group-btn-box{
                position: relative;
                top: 0;
                left: 0;
                width: 100%;
                margin-top: 40px;
                padding-bottom: 1.25rem;
            }
        }
    }
}
</style>